<script>
	import { fly } from 'svelte/transition';
  import Checkmark from "./components/Checkmark.svelte";

  const ADDITION = "addition";
  const SUBTRACTION = "subtraction";
  const MULTIPLICATION = "multiplication";
  const DIVISION = "division";
	let operation;


  let problems = [];
  let numProblems = 10;
  $: numProblems = numProblems > 100 ? 100 : numProblems;
  let digits = 1;

  function generateRandomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function getRandomInt() {
    const nine = "9";
    return Number(generateRandomInteger(0, nine.repeat(digits)));
  }

  function generateProblems(type) {
		problems = [];

		setTimeout(() => generate(), 750);

		function generate() {
			for (let n = 0; n < numProblems; n++) {
				const id = n;
				let num1 = getRandomInt();
				let num2 = getRandomInt();
				let answer;

				if (type === "+") {
					operation = ADDITION;
					answer = num1 + num2;
				}

				if (type === "-") {
					operation = SUBTRACTION;

					if (num1 < num2) {
						const max = "9".repeat(digits);
						num1 = generateRandomInteger(num2, max);
					}
					answer = num1 - num2;
				}

				if (type === "×") {
					operation = MULTIPLICATION;
					answer = num1 * num2;
				}

				if (type === "÷") {
					operation = DIVISION;
					answer = num1 / num2;
				}

				const nums = { num1, num2, answer, id, type, val: "", correct: false };

				problems = [...problems, nums];
			}
		}
  }

  function checkAnswer(id, e) {
    if (e.keyCode < 48 || e.keyCode > 57) {
      return;
    }

    const answer = Number(e.target.value);
    // problems[id].val = answer;
    problems[id].correct = problems[id].answer === answer;

    if (problems[id].correct) {
      playSound();
    }
	}

	function incrementDigit(num) {
		digits = digits + num;
	}

  let activeSound = "1";
  const sounds = [
    "1.mp3",
    "2.mp3",
    "3.mp3",
    "4.mp3",
    "5.mp3",
    "6.mp3",
    "7.mp3",
    "8.mp3",
    "9.mp3",
    "10.mp3",
    "11.mp3",
    "12.mp3",
    "13.mp3",
    "14.mp3",
    "15.mp3"
  ];
  function playSound() {
    activeSound = sounds[Math.floor(Math.random() * sounds.length)];
    const audio = new Audio(`/sounds/${activeSound}`);
    audio.play();
  }
</script>


<div class="bg-gray-100 min-h-screen">

  <main class="max-w-4xl mx-4 px-4 sm:mx-auto">
    <div class="title relative">
      <h1 class="font-bold uppercase text-center flex justify-center">
				<span class="anim delay-1">M</span>
				<span class="anim delay-2">a</span>
				<span class="anim delay-3">t</span>
				<span class="anim delay-4">h</span>
				<span class="p-2 md:p-6"></span>
				<span class="anim delay-5">W</span>
				<span class="anim delay-6">o</span>
				<span class="anim delay-7">r</span>
				<span class="anim delay-8">k</span>
				<span class="anim delay-9">s</span>
				<span class="anim delay-10">h</span>
				<span class="anim delay-11">e</span>
				<span class="anim delay-12">e</span>
				<span class="anim delay-13">t</span>
				<span class="anim delay-14">s</span>
			</h1>
    </div>

		<div class="lg:flex mt-8">
			<div class="sm:flex">
				<div class="items-center">
					<label for="numProblems" class="block">Number of Problems</label>
					<input
						type="number"
						bind:value={numProblems}
						id="numProblems"
						class="mt-2 w-16 px-4 py-2 rounded-tl-lg rounded-br-lg text-center shape-shadow" />
				</div>
				<div class="items-center sm:ml-8">
					<label for="numDigits" class="block">Max Number of Digits</label>
					<input
						type="number"
						bind:value={digits}
						id="numDigits"
						class="mt-2 w-16 px-4 py-2 rounded-tl-lg rounded-br-lg text-center shape-shadow" />
						<button on:click={e => incrementDigit(1)} class="border-1 bg-gray-200 shape-shadow hover:bg-gray-900 hover:text-pink-400 px-4 py-2 ml-2 rounded-tl-lg rounded-br-lg">+</button>
						<button on:click={e => incrementDigit(-1)} class="border-1 bg-gray-200 shape-shadow hover:bg-gray-900 hover:text-pink-400 px-4 py-2 ml-2 rounded-tl-lg rounded-br-lg">-</button>
				</div>
			</div>

			<div class="flex flex-col sm:block btn-group ml-auto mt-8 lg:mt-0">
				<p>Choose operation</p>
				<button
					class:bg-gray-900={operation === ADDITION}
					class:text-gray-200={operation === ADDITION}
					class:bg-white={operation !== ADDITION}
					class:text-gray-800={operation !== ADDITION}
					class="mt-2 px-4 py-4 md:py-2 rounded-tl-lg rounded-br-lg hover:bg-pink-600
					hover:text-white font-bold uppercase shape-shadow"
					on:click={() => generateProblems('+')}>
					Addition
				</button>
				<button
					class:bg-gray-900={operation === SUBTRACTION}
					class:text-gray-200={operation === SUBTRACTION}
					class:bg-white={operation !== SUBTRACTION}
					class:text-gray-800={operation !== SUBTRACTION}
					class="mt-2 px-4 py-4 md:py-2 mt-4 sm:mt-0 sm:ml-4 rounded-tl-lg
					rounded-br-lg hover:bg-pink-600 text-gray-800 hover:text-white font-bold
					uppercase shape-shadow"
					on:click={() => generateProblems('-')}>
					Subtraction
				</button>
				<button
					class:bg-gray-900={operation === MULTIPLICATION}
					class:text-gray-200={operation === MULTIPLICATION}
					class:bg-white={operation !== MULTIPLICATION}
					class:text-gray-800={operation !== MULTIPLICATION}
					class="mt-2 px-4 py-4 md:py-2 mt-4 sm:mt-0 sm:ml-4 rounded-tl-lg
					rounded-br-lg hover:bg-pink-600 text-gray-800 hover:text-white font-bold
					uppercase shape-shadow"
					on:click={() => generateProblems('×')}>
					Multiplication
				</button>
				<!-- <button
					class:bg-gray-900={operation === DIVISION}
					class:text-gray-200={operation === DIVISION}
					class:bg-white={operation !== DIVISION}
					class:text-gray-800={operation !== DIVISION}
					class="px-4 py-4 md:py-2 mt-4 sm:mt-0 sm:ml-4 rounded-tl-lg
					rounded-br-lg hover:bg-pink-600 text-gray-800 hover:text-white font-bold
					uppercase shape-shadow"
					on:click={() => generateProblems('÷')}>
					Division
				</button> -->
			</div>
		</div>

    <div class="md:grid grid-cols-3 gap-6 text-3xl">
      {#each problems as p}
        <div
					key={p.id}
					transition:fly="{{ y: 200, duration: p.id * 1000 }}"
          class="w-4/5 sm:w-2/3 md:w-full mx-auto mt-24 md:mx-0 px-8 bg-white
          font-display rounded-tl-lg rounded-br-lg shape-shadow border border-gray-400 card transition duration-300">
          <!-- <span class="text-xs text-left text-gray-600 text-left inline-block px-2">{p.id}</span> -->
          <div class="border-b border-gray-400 mt-4 text-right">
            <Checkmark isChecked={p.correct} />
            {p.num1}
            <br />
            <span class="font-default font-thin text-lg">{p.type}</span>
            {p.num2}
          </div>
          <input
            on:keyup={e => checkAnswer(p.id, e)}
            bind:value={p.val}
            type="number"
            class="w-full border-0 py-2 text-pink-500 text-right focus:bg-white
            focus:outline-none answer-input" />
        </div>
      {/each}
    </div>

  </main>

</div>
